import { fmtNum, fmtDateLabel } from '../../utils/format';

export default function OCSubBar({ data, symbol, onSymbolChange, onDateChange }) {
  const d = data;
  if (!d) return null;

  const oi = d.oiCoi || {};
  const ceOiClass = (oi.total_ce_oi > oi.total_pe_oi) ? 'sr' : 'sg';
  const peOiClass = (oi.total_pe_oi > oi.total_ce_oi) ? 'sg' : 'sr';
  const ceCoiClass = (Math.abs(oi.total_ce_coi) > Math.abs(oi.total_pe_coi)) ? 'sr' : 'sg';
  const peCoiClass = (Math.abs(oi.total_pe_coi) > Math.abs(oi.total_ce_coi)) ? 'sg' : 'sr';

  return (
    <div className="oc-sub">
      <select value={symbol} onChange={e => onSymbolChange(e.target.value)}>
        <option value="NIFTY">NIFTY</option>
        <option value="BANKNIFTY">BANKNIFTY</option>
        <option value="FINNIFTY">FINNIFTY</option>
      </select>
      <div className="oc-db">
        <div>
          <div className="dl"><i className="bi bi-calendar3" /> DATE</div>
          <select
            className="dval"
            style={{ background: 'transparent', border: 'none', color: 'var(--brand-primary)', fontWeight: 700, fontSize: 11, cursor: 'pointer' }}
            value={d.selectedDate}
            onChange={e => onDateChange(e.target.value)}
          >
            {(d.availableDates || []).map(dt => (
              <option key={dt} value={dt}>{fmtDateLabel(dt)}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="oc-nt"><b>NSE:</b> {d.timestamps?.nse_time || '—'}</div>
      <div className="oc-sep" />
      <div className="oc-st">
        <div className="sp"><span className="sl">SPOT</span><span className="sv sg">{fmtNum(d.spotPrice)}</span></div>
        <div className="sp"><span className="sl">MAX PAIN</span><span className="sv">{fmtNum(d.maxPain, 0)}</span></div>
        <div className="sp"><span className="sl">PCR</span><span className="sv">{d.pcr}</span></div>
        <div className="sp"><span className="sl">CE DECAY</span><span className={`sv ${d.callDecay >= 0 ? 'sg' : 'sr'}`}>{fmtNum(d.callDecay)}</span></div>
        <div className="sp"><span className="sl">PE DECAY</span><span className={`sv ${d.putDecay >= 0 ? 'sr' : 'sg'}`}>{fmtNum(d.putDecay)}</span></div>
        <div className="sp"><span className="sl">SIGNAL</span><span className={`sv ${d.decayConclusion === 'BULLISH' ? 'sg' : 'sr'}`}>{d.decayConclusion}</span></div>
        <div className="oi-bx">
          <div className="oi-hd">TOTAL OI (L)</div>
          <div className="oi-row">
            <div><div className="oi-lbl">CE</div><div className={`oi-val ${ceOiClass}`}>{fmtNum((oi.total_ce_oi || 0) / 100000, 1)}</div></div>
            <div><div className="oi-lbl">PE</div><div className={`oi-val ${peOiClass}`}>{fmtNum((oi.total_pe_oi || 0) / 100000, 1)}</div></div>
          </div>
        </div>
        <div className="oi-bx">
          <div className="oi-hd">TOTAL COI (L)</div>
          <div className="oi-row">
            <div><div className="oi-lbl">CE</div><div className={`oi-val ${ceCoiClass}`}>{fmtNum(Math.abs(oi.total_ce_coi || 0) / 100000, 1)}</div></div>
            <div><div className="oi-lbl">PE</div><div className={`oi-val ${peCoiClass}`}>{fmtNum(Math.abs(oi.total_pe_coi || 0) / 100000, 1)}</div></div>
          </div>
        </div>
      </div>
    </div>
  );
}